import {useTranslation} from "react-i18next";
import {Card} from "antd";
import {useEffect} from "react";
import CardTitle from "../../core/components/CardTitle";
import AppConfig from "../../core/service/AppConfig";
import AppLogViewer from "../../app/log/app-log-viewer/AppLogViewer";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";

export default function AppLogViewerPage()
{
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('App Logs')} | ${AppConfig.getRisTitle()}`
    }, []);

    // Sider yok (sidebarComponent verilmiyor → 0 genişliğe çöker), tam genişlikte içerik.
    return (
        <LayoutWithSider fullWidth={true}>
            <Card title={<CardTitle title={t('App Logs')} />}>
                <AppLogViewer />
            </Card>
        </LayoutWithSider>
    )
}
